export enum DefaultRefundRequestTabsEnum {
    Protocol = 0,
    SelecaoBeneficiario = 1,
    DadosParaCreditoEmConta = 2,
    DadosPrestador = 3,
    DadosProcedimento = 4,
    AnexosMotivo = 5,
    TermosFinalizacao = 6,
}